/*
 * @Author: 代码尊 gaojianstyle@163.com
 * @Date: 2023-01-18 05:55:09
 * @LastEditors: 代码尊 gaojianstyle@163.com
 * @LastEditTime: 2023-01-19 16:38:53
 * @FilePath: \g-vue3\src\store\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createStore } from 'vuex'

/**
 * @description: 
 * @param {any} num
 * @return {*}
 */
function demo(num: any) {
  return 1;
}


export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})

